export interface Pharmacovigilance {
  indskr_pharmacovigilancereportingid: string;
  statecode?: number;
  statuscode?: number;
  modifiedon: string;
  indskr_name: string;
  indskr_recontactreport?: boolean;
  indskr_descriptionofevent?: string;
  indskr_phone?: string;
  indskr_dateofawareness?: string;
  indskr_acinodrugtaken?: string;
  indskr_patientidentifier?: string;
  indskr_address?: string;
  indskr_email?: string;
}

export interface PharmacovigilanceCreateDTO {
  modifiedon?: string;
  indskr_name: string;
  indskr_recontactreport?: boolean;
  indskr_descriptionofevent?: string;
  indskr_phone?: string;
  indskr_dateofawareness?: string;
  indskr_acinodrugtaken?: string;
  indskr_patientidentifier?: string;
  indskr_address?: string;
  indskr_email?: string;
}

export interface PharmacovigilanceCreateResponseDTO {
  indskr_pharmacovigilancereportingid: string;
  modifiedon: string;
}

export interface PharmacovigilanceInfoBtnDataValue {
  text?: string;
  tableHeader?: string[];
  tableRows?: string[][];
};

export interface PharmacovigilanceInfoBtnData {
  configName: string;
  value: PharmacovigilanceInfoBtnDataValue;
};

export type PharmacovigilanceInfoModalDataType = 'text' | 'table';
export type PharmacovigilanceBtnConfigNameAndDataTypeMapping = { [key: string]: { configName: string, dataType: PharmacovigilanceInfoModalDataType } };
export interface PharmacovigilanceInfoModalData {
  title: string;
  dataType: PharmacovigilanceInfoModalDataType;
  data: PharmacovigilanceInfoBtnDataValue;
};